import styled from '@bd/bdui-styles/emotion';
import ContentBanner from '@bd/bdui-contentbanner';
import { grid, colors, typography } from '../styles';

export default styled(ContentBanner)`
  width: 100%;
  .ContentBanner_wrapper {
      width: 100%;
  }
  .ContentBanner_inner {
    width: 100%;
    max-width: 2000px;
    margin: 0 auto;
  }
  .ContentBanner_result {
    ${grid.makeRow()};
    margin-bottom: 45px;
    @media (min-width: 992px) {
      margin-bottom: 0;
    }
  }
  .ContentBanner_resultMedia {
    ${grid.makeCol(12)}
    background-size: cover;
    background-position: center center;
    display: flex;
    @media (min-width: 992px) {
      ${grid.makeCol(6)}
      padding: 0;
    }
  }
  .ContentBanner_resultMediaInner {
    width: 100%;
    background-color: #F5F5F5;
    background-size: cover;
    background-position: center center;
    padding-top: 56.25%;
    @media (min-width: 992px) {
    }
  }
  .ContentBanner_resultContent {
    ${grid.makeCol(12)}
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 30px;
    @media (min-width: 992px) {
      ${grid.makeCol(6)}
      background-color: #F5F5F5;
      padding: 90px;
      padding-right: 60px;
      padding-left: 60px;
    }
    p {
      font-size: 17px;
      line-height: 2;
    }
    ul {
      padding: 0;
      list-style: none;
    }
    li {
      padding: 10px 0 10px 20px;
      border-bottom: 1px solid ${colors.color1Darker};
      &:last-child {
        border: 0;
      }
      &:before {
        content: '\\25A0';
        display: inline-block;
        color: ${colors.color2};
        margin: 0 10px 0 -20px;
      }
    }
  }
  .ContentBanner_title {
    font-size: 24px;
    color: ${colors.color1};
    font-family: ${typography.Serif};
    margin: 0 0 40px 0;
    position: relative;
    &:after {
      content: '';
      position: absolute;
      display: block;
      left: 0;
      bottom: -26px;
      width: 60px;
      height: 3px;
      background-color: ${colors.color2};
    }
  }
  .ContentBanner_preTitle {
    font-weight: normal;
    display: block;
    font-size: 16px;
  }
  .ContentBanner_body {
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      flex-wrap: wrap;
      li {
        font-weight: 200;
        font-size: 16px;
        color: #424242;
        letter-spacing: 0;
        line-height: 21px;
        position: relative;
        width: 100%;
        padding: 10px 20px;
        border-bottom: none;
        @media(min-width: 992px) {
          padding: 15px 30px 20px 20px;
          width: 50%;
          font-size: 20px;
          line-height: 26px;
        }
        &::before {
          content: '';
          width: 10px;
          height: 10px;
          background-color: ${colors.color1};
          display: flex;
          position: absolute;
          left: 10px;
          top: 20px;
          @media(min-width: 992px) {
            width: 11px;
            height: 11px;
            top: 23px;
          }
        }
      }
    }
  }
  ${props => (!props.alternating ? '' : `
    &:nth-child(even) {
      .ContentBanner_result {
        flex-direction: row-reverse;
      }
      .ContentBanner_resultContent {
        background-color: #FFFFFF;
        li {
          padding: 10px 0 10px 20px;
          border-bottom: 1px solid #eeeeee;
        }
      }
    }
  `)}
`;



// WEBPACK FOOTER //
// ./src/components/PageSectionContent.js